import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectRegionId } from '../../../selectors/regionId';
import { selectJsonQuery } from '../../../selectors/results';
import { getAdfoxPuidParams } from '../../../utils/getAdfoxPuidParams';
import { generateRandomString } from '../utils';

import type { TAdBannerCommonParameters } from '../types';

const DEFAULT_REGION_ID = 1;

/**
 * Общие для всех мест параметры: puid'ы и регион берём из состояния хоста,
 * placeId генерируем один раз на маунт баннера.
 */
export function useAdBannerCommonParameters(): TAdBannerCommonParameters {
  const jsonQuery = useSelector(selectJsonQuery);
  // Регион в состоянии карты nullable; фолбэк на Москву — та же дефолтная подстановка,
  // что и при запросе манифеста микрофронтенда фильтров.
  const regionId = useSelector(selectRegionId) ?? DEFAULT_REGION_ID;

  const placeId = React.useMemo(() => generateRandomString(), []);

  const puids = React.useMemo<Record<string, string>>(
    () =>
      Object.entries(getAdfoxPuidParams(jsonQuery)).reduce<Record<string, string>>((acc, [key, value]) => {
        if (value) {
          acc[key] = value;
        }

        return acc;
      }, {}),
    [jsonQuery],
  );

  return React.useMemo<TAdBannerCommonParameters>(() => ({ puids, regionId, placeId }), [puids, regionId, placeId]);
}
